import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class KwikUIButtonLiveLocationPermissionService {
  constructor() {}

  askForPermission(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.permissions
          .query({ name: "geolocation" })
          .then((permissionStatus) => {
            if (permissionStatus.state === "granted") {
              resolve(true);
            } else if (permissionStatus.state === "prompt") {
              navigator.geolocation.getCurrentPosition(
                () => {
                  resolve(true);
                },
                () => {
                  reject(false);
                }
              );
            } else {
              reject(false);
            }
          });
      } else {
        reject(false);
      }
    });
  }

  getLocation(): Promise<{
    latitude: number;
    longitude: number;
    timestamp: number;
  }> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              timestamp: Date.now()
            });
          },
          () => {
            reject("Error getting location");
          }
        );
      } else {
        reject("Geolocation not supported");
      }
    });
  }
}
